import type { ReactNode } from "react";
import { cn } from "./cn";
import { Ikon, type IkonAdi } from "./Ikon";

export interface FiltreKartiProps {
  /** Kartın küçük kalın başlığı ("Öğrenci ve Filtreler"); verilmezse başlık satırı çizilmez. */
  baslik?: ReactNode;
  ikon?: IkonAdi;
  /**
   * Alanlar kaç sütuna dizilsin (geniş ekranda). Verilmezse çocuklar olduğu gibi
   * çizilir — ekran kendi ızgarasını kurabilir. Telefonda her zaman TEK sütun.
   */
  sutun?: 2 | 3 | 4;
  /** Alanların ALTINDAKİ düğme satırı: birincil "Uygula/Getir" + kesikli "Temizle". */
  eylemler?: ReactNode;
  children: ReactNode;
  className?: string;
}

/*
  Sınıf adları TAM yazılıyor, birleştirilmiyor: Tailwind kaynağı metin olarak
  tarıyor ve `lg:grid-cols-${n}` gibi bir şablonu göremez — sınıf üretilmez,
  ızgara sessizce tek sütuna düşer.
*/
const SUTUN: Record<NonNullable<FiltreKartiProps["sutun"]>, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-4",
};

/**
 * FİLTRE KARTI — UNİKOÇ kalıbı (sürüm 9a; tarama-1 §2.11, tarama-2 §2.6)
 *
 * Başlık bandının hemen altında duran beyaz kart: üstte etiketli alanlar
 * (Başlangıç, Bitiş, Durum, Öğrenci...), altta "Uygula" + "Temizle". Eski
 * panelde her liste ekranında aynı kalıp vardı; burada tek bileşen, ki
 * köşe/boşluk/gölge ekrandan ekrana kaymasın.
 */
export function FiltreKarti({
  baslik,
  ikon,
  sutun,
  eylemler,
  children,
  className,
}: FiltreKartiProps) {
  return (
    <section
      data-ui="filtre-karti"
      className={cn(
        "bg-notr-0 border-mor-kenar rounded-[1.5rem] border shadow-(--golge-unk-kart)",
        "p-4 md:p-6",
        className,
      )}
    >
      {baslik && (
        <h2 className="text-metin-koyu mb-3 flex items-center gap-2 text-[0.9375rem] font-bold">
          {ikon && <Ikon ad={ikon} className="text-metin-koyu size-4" />}
          {baslik}
        </h2>
      )}
      {sutun ? <div className={cn("grid gap-4", SUTUN[sutun])}>{children}</div> : children}
      {eylemler && <div className="mt-4 flex flex-wrap items-center gap-2">{eylemler}</div>}
    </section>
  );
}
